module.exports = __webpack_public_path__ + "static/media/javascript-4.7fd50466.svg";